import { useState } from 'react'
import styled from '@emotion/styled'
import { motion, Variants } from 'framer-motion'

import SVGLoader from '@src/components/svg/SVGLoader'

type SideBarListProps = {
	children: React.ReactNode
	title: string
}

const SideBarList = ({ title, children }: SideBarListProps) => {
	return (
		<ListBlock>
			<ListHeader>
				<Title>{title}</Title>
				<ArrowIconBlock>
					<SVGLoader name="leftArrowIcon" />
				</ArrowIconBlock>
			</ListHeader>
			<ItemBlock>{children}</ItemBlock>
		</ListBlock>
	)
}

const ListBlock = styled.div`
	margin-bottom: 3.55rem;

	&:nth-last-of-type(1) {
		margin-bottom: 0;
	}
`

const ListHeader = styled.div`
	display: flex;
	justify-content: space-between;
	font-size: 1.4rem;
	color: #92959e;
	padding-left: 3.8rem;
	padding-right: 0.8rem;
	cursor: pointer;
`

const Title = styled.span``

const ArrowIconBlock = styled.div`
	width: 1.3rem;
	height: 1.1rem;

	svg {
		color: #92959e;
		transform: rotate(-90deg);
	}
`

const ItemBlock = styled(motion.ul)`
	margin-top: 1.3rem;
`

export default SideBarList
